export interface Enquiry {
  name: string;
  email: string;
  company: string;
  interest: string;
  budget: string;
  message: string;
}

export class SubmissionError extends Error {
  constructor(message = 'We could not send that. Please try again or email us directly.') {
    super(message);
    this.name = 'SubmissionError';
  }
}

/**
 * The one place the site talks to a server. This build has no backend, so the
 * call is stubbed — replace the body with the real request and everything
 * upstream (loading, error and success states) keeps working unchanged:
 *
 *   const response = await fetch('/api/enquiries', {
 *     method: 'POST',
 *     headers: { 'Content-Type': 'application/json' },
 *     body: JSON.stringify(enquiry),
 *     signal,
 *   });
 *   if (!response.ok) throw new SubmissionError();
 */
export function submitEnquiry(enquiry: Enquiry, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(signal.reason);
      return;
    }

    const timer = setTimeout(() => {
      signal?.removeEventListener('abort', onAbort);
      if (import.meta.env.DEV) console.info('[qvantum-os] enquiry (stubbed submit)', enquiry);
      resolve();
    }, 900);

    function onAbort() {
      clearTimeout(timer);
      reject(signal?.reason);
    }

    signal?.addEventListener('abort', onAbort, { once: true });
  });
}
